<template>
  <div>
    <vx-card>
      <div class="vx-row flex flex-wrap-reverse items-center flex-grow mb-2">
        <vs-button class="rounded-lg mr-2" color="warning" type="filled" @click="reloadTree" icon-pack="feather"
          icon="icon-refresh-ccw">Reload</vs-button>
        <vs-button class="rounded-lg mr-2" color="success" type="filled" @click="addNewEquipment" icon-pack="feather"
          icon="icon-plus-square">Add New Equipment</vs-button>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <el-tree :data="treeData" node-key="id" class="treenode vs-con-loading__container" ref="equipTree"
            highlight-current :props="defaultProps" draggable @node-drag-start="handleDragStart"
            @node-drag-end="handleDragEnd" @node-drop="handleDrop" :allow-drop="allowDrop" :allow-drag="allowDrag">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>
                <strong>Level {{ node.level - 1 }}:</strong>
                <template v-if="node.level === 1">
                  Equipment: {{ data.Registration }}
                </template>
                <template v-else-if="node.level === 2">
                  Asset: {{ data.AssetName }}
                </template>
                <template v-else-if="node.level === 3">
                  Operation: {{ data.Allocation1 }}
                </template>
                <template v-else-if="node.level === 4">
                  Location: {{ data.Allocation2 }}
                </template>
              </span>
              <span>
                <el-button style="margin-left: 1vw; padding: 5px" :class="getLevelClass(node.level)" type="text"
                  size="small" @click="addChild(node)">
                  Add Child
                </el-button>
                <!-- <el-button style="margin-left: 1vw; padding: 5px" type="text" size="small" @click="removeNode(node)">
                  Delete
                </el-button> -->
              </span>
            </span>
          </el-tree>
        </div>
      </div>
    </vx-card>
    <vs-prompt ref="addPrompt" :title="`Add Equipment Asset Link`" acceptText="Submit" cancelText="Cancel"
      @cancel="promptActive = false" @accept="submitAddEqp" :active.sync="promptActive">
      <div>
        <label>Select Equipment</label>
        <v-select ref="equipment" class="w-full h-1/2" placeholder="Select Equipment" :options="equipmentsData"
          v-model="selectedEquipment">
        </v-select>

        <label>Select Asset</label>
        <v-select ref="asset" class="w-full h-1/2" placeholder="Select Asset" :options="assetsData"
          v-model="selectedAsset">
        </v-select>
        <div class="vx-row">
          <div class="vx-col md:w-full mt-5">
            <vs-input label="Asset Description" v-model="description" class="w-full" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 mt-5">
            <label class="w-full">Operations</label>
            <v-select placeholder="Select Operation" :options="allocations1Data"
              v-model="selectedAllocation1"></v-select>
          </div>
          <div class="vx-col md:w-1/2 mt-5">
            <label class="w-full">Locations</label>
            <v-select class="w-full" placeholder="Select Location" :options="allocations2Data"
              v-model="selectedAllocation2"></v-select>
          </div>
        </div>
      </div>
    </vs-prompt>

    <vs-prompt ref="addPrompt" :title="`Link Asset to Equipment`" acceptText="Submit" cancelText="Cancel"
      @cancel="promptActiveAsset = false" @accept="submitLinkAsset" :active.sync="promptActiveAsset">
      <div>
        <label>Select Asset</label>
        <v-select ref="asset" class="w-full h-1/2" placeholder="Select Asset" :options="assetsData"
          v-model="selectedAsset">
        </v-select>
      </div>
    </vs-prompt>

    <vs-prompt ref="addPrompt" :title="`Add Operation to Asset`" acceptText="Submit" cancelText="Cancel"
      @cancel="promptActiveAllocation1 = false" @accept="submitAddOps" :active.sync="promptActiveAllocation1">
      <div>
        <label>Select Operation</label>
        <v-select ref="operation" class="w-full h-1/2" placeholder="Select Operation" :options="allocations1Data"
          v-model="selectedAllocation1">
        </v-select>
        <label>Select Location</label>
        <v-select ref="location" class="w-full h-1/2" placeholder="Select Location" :options="allocations2Data"
          v-model="selectedAllocation2">
        </v-select>
      </div>

    </vs-prompt>

    <vs-prompt ref="addPrompt" :title="`Add Location to Asset`" acceptText="Submit" cancelText="Cancel"
      @cancel="promptActiveAllocation2 = false" @accept="submitAddOps" :active.sync="promptActiveAllocation2">
      <div>
        <label>Select Location</label>
        <v-select ref="location" class="w-full h-1/2" placeholder="Select Location" :options="allocations2Data"
          v-model="selectedAllocation2">
        </v-select>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import VxCard from '../../../components/vx-card/VxCard.vue';
import 'element-ui/lib/theme-chalk/index.css';
import vSelect from "vue-select";

export default {
  components: {
    VxCard,
    "v-select": vSelect,
    // ElTree,
    // ElButton
  },
  data() {
    return {
      rawData: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      promptActive: false,
      promptActiveAsset: false,
      promptActiveAllocation1: false,
      promptActiveAllocation2: false,
      promptLevel: 1,
      promptValue: '',
      activeNode: null,

      equipmentsData: [],
      selectedEquipment: null,

      assetsData: [],
      selectedAsset: null,

      allocations1Data: [],
      selectedAllocation1: null,

      allocations1Data: [],
      selectedAllocation1: null,

      allocations2Data: [],
      selectedAllocation2: null,

      description: '',
    };
  },
  mounted() {
    this.getTreeData();
    this.getEquipments();
    this.getAssets();
    this.getAllocations(1);
    this.getAllocations(2);
  },
  methods: {
    initValues(){
      var self = this;
      self.rawData = [];
      self.treeData = [];
      self.promptActive = false;
      self.promptActiveAsset = false;
      self.promptActiveAllocation1 = false;
      self.promptActiveAllocation2 = false;
      self.promptLevel = 1;
      self.promptValue = '';
      self.activeNode = null;
      self.equipmentsData = [];
      self.selectedEquipment = null;
      self.assetsData = [];
      self.selectedAsset = null;
      self.allocations1Data = [];
      self.selectedAllocation1 = null;
      self.allocations1Data = [];
      self.selectedAllocation1 = null;
      self.allocations2Data = [];
      self.selectedAllocation2 = null;
      self.description = '';
      self.getTreeData();
      self.getEquipments();
      self.getAssets();
      self.getAllocations(1);
      self.getAllocations(2);
    },
    getLevelClass(level) {
      switch (level) {
        case 1: return 'btn-level-1';
        case 2: return 'btn-level-2';
        case 3: return 'btn-level-3';
        case 4: return 'btn-level-4';
        default: return 'btn-default';
      }
    },
    buildTree(data) {
      const equipmentMap = {};

      data.forEach(row => {
        // --- Equipment ---
        if (!equipmentMap[row.registration]) {
          equipmentMap[row.registration] = {
            id: row.eid,
            Registration: row.registration,
            Allocation1: row.ops,
            Allocation2: row.location,
            peaaId: row.peaaid,
            EquipmentId: row.eid,
            AssetId: row.eaid,
            OpsId: row.allocation1ID,
            LocationId: row.allocation2ID,
            description: row.assetDesc,
            children: {}
          };
        }
        const equip = equipmentMap[row.registration];

        // --- EquipmentAsset ---
        if (!equip.children[row.eaName]) {
          equip.children[row.eaName] = {
            id: row.eaId,
            AssetName: row.eaName,
            Allocation1: row.ops,
            Allocation2: row.location,
            peaaId: row.peaaid,
            EquipmentId: row.eid,
            AssetId: row.eaid,
            OpsId: row.allocation1ID,
            LocationId: row.allocation2ID,
            description: row.assetDesc,
            children: {}
          };
        }
        const asset = equip.children[row.eaName];

        // --- Allocation1 ---
        if (row.ops) {
          if (!asset.children[row.ops]) {
            asset.children[row.ops] = {
              id: row.allocation1ID,
              Allocation1: row.ops,
              Allocation2: row.location,
              peaaId: row.peaaid,
              EquipmentId: row.eid,
              AssetId: row.eaid,
              OpsId: row.allocation1ID,
              LocationId: row.allocation2ID,
              description: row.assetDesc,
              children: {}
            };
          }
        }
        const alloc1 = asset.children[row.ops];

        // --- Allocation2 ---
        if (row.location) {
          if (!alloc1.children[row.location]) {
            alloc1.children[row.location] = {
              id: row.allocation2ID,
              Allocation1: row.ops,
              Allocation2: row.location,
              peaaId: row.peaaid,
              EquipmentId: row.eid,
              AssetId: row.eaid,
              OpsId: row.allocation1ID,
              LocationId: row.allocation2ID,
              description: row.assetDesc,
              children: []
            };
          }
        }
      });

      // Convert nested objects to arrays for el-tree
      return Object.values(equipmentMap).map(equip => ({
        ...equip,
        children: Object.values(equip.children).map(asset => ({
          ...asset,
          children: Object.values(asset.children).map(alloc1 => ({
            ...alloc1,
            children: Object.values(alloc1.children)
          }))
        }))
      }));
    },
    getTreeData(){
      const self = this;
      var onSuccess = function (response) {
        self.rawData = response.data;
        self.treeData = self.buildTree(response.data);
      };
      var onFinally = function () {
        // self.$vs.loading.close(self.$refs.categorySelect.$el);
      };
      self.$ajaxGet(self, "PerAllocationStoresSchedule6", onSuccess, onFinally);
    },
    reloadTree() {
      this.getTreeData();
    },
    addNewEquipment() {
      this.promptLevel = 1;
      this.promptValue = '';
      this.activeNode = null;
      this.promptActive = true;
    },
    addChild(node) {
      this.activeNode = node;
      this.promptLevel = node.level;
      if (node.level === 1) {
        // this.promptValue = '';
        // this.getEquipments();
        // this.promptActive = true;
        this.promptValue = '';
        this.getAssets();
        this.promptActiveAsset = true;
      }
      else if (node.level === 2) {
        this.promptValue = '';
        this.getAllocations(1);
        this.promptActiveAllocation1 = true;
      }
      else if (node.level === 3) {
        this.promptValue = '';
        this.getAllocations(2);
        this.promptActiveAllocation2 = true;
      }
      else if (node.level === 4) {
      }
    },
    submitAddChild() {
      if (!this.promptValue) return;
      if (!this.activeNode) {
        // Add new Equipment
        this.treeData.push({
          id: this.promptValue,
          Registration: this.promptValue,
          children: []
        });
      } else {
        // Add child at correct level
        const node = this.activeNode;
        if (node.level === 1) {
          node.data.children.push({
            id: node.data.Registration + '-' + this.promptValue,
            AssetName: this.promptValue,
            children: []
          });
        } else if (node.level === 2) {
          node.data.children.push({
            id: node.data.id + '-' + this.promptValue,
            Allocation2: this.promptValue,
            children: []
          });
        } else if (node.level === 3) {
          node.data.children.push({
            id: node.data.id + '-' + this.promptValue,
            Allocation1: this.promptValue,
            children: []
          });
        }
      }
      this.promptActive = false;
      this.promptValue = '';
      this.activeNode = null;
    },
    removeNode(node) {
      const parent = node.parent;
      if (!parent) {
        // Remove root
        this.treeData = this.treeData.filter(e => e.id !== node.data.id);
      } else {
        const siblings = parent.data.children;
        const idx = siblings.findIndex(child => child.id === node.data.id);
        if (idx !== -1) siblings.splice(idx, 1);
      }
    },
    handleDragStart(node, ev) {
      // Optional: implement drag logic
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      // Optional: implement drag logic
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      // Optional: implement drop logic
    },
    allowDrop(draggingNode, dropNode, type) {
      return true;
    },
    allowDrag(draggingNode) {
      return true;
    },
    getEquipments() {
      var self = this;
      var onSuccess = function (response) {
        self.equipmentsData = response.data.map((item) => {
          return { label: item.registration, value: item.id };
        });
      };
      self.$ajaxGet(self, "PerAllocationStoresSchedule6/GetEquipmentDropDownUnassigned", onSuccess);
    },
    submitAddEqp(){
      var self = this;
      console.log("submitAddEqp");

      console.log(this.selectedEquipment);
      console.log(this.selectedAsset);
      if(!this.selectedEquipment || !this.selectedAsset || !this.selectedAllocation1 || !this.selectedAllocation2) {
        console.error("Missing required fields");
        return;
      }
      var obj = {
        eid: this.selectedEquipment.value || 0,
        eaid: this.selectedAsset.value || 0,
        description: this.description || '',
        allocation1id: this.selectedAllocation1.value || 0,
        allocation2id: this.selectedAllocation2.value || 0,
      };

      var onSuccess = (response) => {
        self.promptActive = false;
        this.getTreeData()
      };
      var onFinally = function () {

      };

      self.$ajaxPost(self, "PerAllocationStoresSchedule6", obj, onSuccess, onFinally);
    },
    getAssets(){
      var self = this;
      var onSuccess = function (response) {
        self.assetsData = response.data.map((item) => {
          return { label: item.name, value: item.id };
        });
      };
      self.$ajaxGet(self, "EquipmentAssets/GetEquipmentAssetsdropdown", onSuccess);
    },
    submitLinkAsset(){
      console.log("submitLinkAsset");
      console.log(this.activeNode);
      console.log(this.selectedAsset);
    },
    getAllocations(level){
      var self = this;
      var onSuccess = function (response) {
        if(level === 1){
          self.allocations1Data = response.data.map((item) => {
            return { label: item.name, value: item.id };
          });
        }
        else if(level === 2){
          self.allocations2Data = response.data.map((item) => {
            return { label: item.name, value: item.id };
          });
        }
      };
      self.$ajaxGet(self, "Allocations/GetAllocationSpecificGroup?allocationTypeId=" + level, onSuccess);
    },
    submitAddOps() {
      var self = this;
      console.log("submitAddOps");
      console.log(self.activeNode);
      console.log(self.selectedAllocation1);


      var obj = {
        peaaId: self.activeNode.data.peaaId || 0,
        eid: self.activeNode.data.EquipmentId || 0,
        eaid: self.activeNode.data.AssetId || 0,
        description: self.activeNode.data.description || '',
        allocation1id: self.selectedAllocation1 ? self.selectedAllocation1.value : 0,
        allocation2id: self.selectedAllocation2 ? self.selectedAllocation2.value : 0,
      };
      var onSuccess = (response) => {
        // if (self.promptActive || self.promptActiveAsset || self.promptActiveAllocation1 || self.promptActiveAllocation2){
          self.promptActive = false;
          self.promptActiveAsset = false;
          self.promptActiveAllocation1 = false;
          self.promptActiveAllocation2 = false;
        // }
        this.initValues();
        // this.getTreeData();
      };
      var onFinally = function () {

      };

      self.$ajaxPost(self, "PerAllocationStoresSchedule6/NewOpsLoc", obj, onSuccess, onFinally);
    },
  }
};
</script>

<style>
.treenode .el-tree__empty-block {
  color: white;
}

.treenode .el-tree-node .el-tree-node__content {
  margin-top: 10px !important;
  margin-bottom: 5px !important;
  border-bottom: gray 1px solid;
  margin-left: 8px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.btn-level-1 {
  background-color: #0000ff;
  color: white;
  visibility: hidden;
}

.btn-level-2 {
  background-color: #00FF00;
  color: black;
}

.btn-level-3 {
  background-color: #FF8000;
  color: white;
}

.btn-level-4 {
  background-color: #E200FF;
  color: white;
  visibility: hidden;
}

.btn-default {
  background-color: #FF0000;
  color: white;
}
</style>
